import { IntlShape } from 'react-intl';
import { Column } from 'react-table';
import { Theme } from '@emotion/react';
import { TableRow } from '@/components/atoms/Table/Table.type';
import { computeText } from '@/locales/utils';
import { RestaurantShift } from '@/services/innovorder/restaurant/restaurant.type';
import { computeDaysOfTheWeek, computeTime } from '@/pages/Brand/Grant/GrantForm/GrantShifts/utils';

export const getShiftsTableRowsVM = (
    shifts: RestaurantShift[] | undefined,
    onDelete: (shift: RestaurantShift) => void,
    intl: IntlShape,
    theme: Theme,
    brandId: string,
): TableRow[] =>
    !shifts
        ? []
        : shifts.map((shift) => ({
              name: {
                  type: 'string',
                  value: { text: shift.isDefault ? computeText(intl, 'shift.badge.default') : shift.name },
              },
              daysOfWeek: { type: 'string', value: { text: computeDaysOfTheWeek(intl, shift.daysOfWeek) } },
              hours: {
                  type: 'string',
                  value: {
                      text: `${computeTime({ start: shift.start, end: shift.end })}${
                          shift.endsTomorrow ? ' (+1)' : ''
                      }`,
                  },
              },
              isEnabled: {
                  type: 'badge',
                  value: {
                      backgroundColor: shift.isEnabled ? theme.color.emerald : theme.color.grey300,
                      text: shift.isEnabled
                          ? computeText(intl, 'shift.badge.enabled')
                          : computeText(intl, 'shift.badge.disabled'),
                      textColor: theme.color.white100,
                      fontWeight: 'bold',
                  },
              },
              isDefault: shift.isDefault
                  ? {
                        type: 'badge',
                        value: {
                            backgroundColor: theme.color.primary,
                            text: computeText(intl, 'shift.badge.default'),
                            textColor: theme.color.white100,
                            fontWeight: 'bold',
                        },
                    }
                  : { type: 'empty', value: '' },
              action: {
                  type: 'action',
                  value: {
                      children: computeText(intl, 'button.delete'),
                      buttonType: 'outlinedPrimary',
                      onClick: () => onDelete(shift),
                  },
              },
              linkTo: {
                  type: 'linkTo',
                  value: { brandId, shiftId: shift.shiftId },
              },
          }));

export const getShiftsTableColumnsVM = (intl: IntlShape): readonly Column<TableRow>[] => [
    {
        Header: computeText(intl, 'shift.column.name'),
        accessor: 'name',
    },
    {
        Header: computeText(intl, 'shift.column.daysOfWeek'),
        accessor: 'daysOfWeek',
    },
    {
        Header: computeText(intl, 'shift.column.hours'),
        accessor: 'hours',
    },
    {
        Header: computeText(intl, 'shift.column.isEnabled'),
        accessor: 'isEnabled',
        maxWidth: 100,
    },
    {
        Header: computeText(intl, 'shift.column.isDefault'),
        accessor: 'isDefault',
        maxWidth: 120,
    },
    {
        Header: computeText(intl, 'shift.column.action'),
        accessor: 'action',
        width: '1%',
        disableSortBy: true,
    },
];
